export class SignupUser {
    public name: string;
    public password: string;
    public role: string;
    constructor() {}
}
